import { connect } from "react-redux";
import get from "lodash/get";

import { setStateVideoPanel as onSetStateVideoPanel, setVideoInterval as onSetVideoInterval } from "../../actions/VideoToolsActions";

const mapStateToProps = (state) => ({
  isOpenVideoPanel: get(state, ["videoTools", "isOpenVideoPanel"], false),
  isOnlineVideo: get(state, ["videoTools", "isOnlineVideo"], true),
  dateStart: get(state, ["videoTools", "dateStart"], null),
  dateEnd: get(state, ["videoTools", "dateEnd"], null),
  deviceId: get(state, ["videoTools", "deviceId"], null),
  channels: get(state, ["videoTools", "channels"], 0),
  token: get(state, ["videoTools", "token"], null),
  speedPlay: get(state, ["videoTools", "speedPlay"], 2),
  errors: get(state, ["videoTools", "errors"], null),
});

const mapDispatchToProps = { onSetStateVideoPanel, onSetVideoInterval };

const withVideoTools = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withVideoTools };
